import React from 'react';

import * as commons from '../commons';
import FormLabel from "./FormLabel";

class FormLableOrderAmmounts extends  React.Component {

  render() {

    const {
      fields,
    } = this.props

    return (

      <div>

        {fields && fields.map((row, index) => {
          return (
            <div className="row" key={index}>
              <div className="col-4">
                <FormLabel
                    title='受注金額(予)'
                    value={commons.dispMoney(row.orderAmmountBudget)}
                />
              </div>
              <div className="col-4">
                <FormLabel
                    title='受注金額(実)'
                    value={commons.dispMoney(row.orderAmmount)}
                />
              </div>
              <div className="col-4">
                <FormLabel
                    title='見積り番号'
                    value={row.estimateCode}
                />
              </div>
            </div>
          )
        })}

      </div>

    )

  }

}

export default FormLableOrderAmmounts


// WEBPACK FOOTER //
// ./src/components/FormLabelOrderAmmounts.js